import { FunctionComponent, useEffect, useRef } from "react";
import styles from "../../pages/Carrinho/Carrinho.module.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCheckout } from "../../context/CheckoutContext";


const PlansCard: FunctionComponent = ({
  text,
  title,
  onSelect,
  selected,
  index,
  id,
  disabled,
}: {
  id: number,
  text: string;
  title: string;
  onSelect: Function;
  selected: boolean;
  index: number;
  disabled: boolean;
}) => {
  const toastId = 'unique-id';
  const { setPlanId, setPlanName } = useCheckout()
  return (
    <>
      <div
        className={selected ? styles.buttonsPlanos1 : styles.buttonsPlanos}
        onClick={() => { 
          if (!disabled) {
            onSelect(index, id)
            setPlanId(id)
            setPlanName(title)
          } else {
            if (!toast.isActive(toastId)) {
            toast.error("Para escolher outro plano, retire as máquinas selecionadas do carrinho", {
              toastId,
              position: "top-right",
            });
          }
          }}}
      >
        <img className={styles.icones2} alt="" src="/icones36.svg" />
        <h4 className={styles.d0}>{title}</h4>
        {text &&
          <div className={styles.saldoDisponvelNo}>{text}</div>
        }
      </div>
    </>
  );
};

export default PlansCard;
